const Sobre = () => (
    <div>
        <h1>Lista de Musicas</h1>
        <h2>Sistema desenvolvido na Disciplina de PW</h2>
    </div>
);
export default Sobre;